import * as actions from "./actions";

export default function groupTypesReducer(state = [], action) {
    switch (action.type) {

    case actions.GET_GROUP_TYPES_SUCCESS:
    case actions.GET_GROUP_TYPES_FAIL:
    {
        return action.payload;
    }
    default:
        return state;

    }
}
